module.exports = __webpack_public_path__ + "static/img/0000个人网站2.0ecb9eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0000个人网站2.jpg
// module id = YBOn
// module chunks = 0